import React, { useEffect } from "react";
import { useApi } from "../hooks/useApi";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export function AccountSelect({ value, onChange, testId, label = "Pay into account", className = "" }) {
  const { data: accounts } = useApi("/payment-accounts");
  useEffect(() => {
    if (!value && accounts?.length) onChange(accounts[0].id);
  }, [accounts, value, onChange]);
  if (!accounts?.length) return null;
  return (
    <div className={className}>
      {label && <Label>{label}</Label>}
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testId}><SelectValue placeholder="Select account" /></SelectTrigger>
        <SelectContent>
          {accounts.map((a) => <SelectItem key={a.id} value={a.id} data-testid={`${testId}-opt-${a.name.toLowerCase().replace(/\s+/g, "-")}`}>{a.name}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
